import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../../Components/Loading";
import Table from "../../Components/Reports/RegAssocTable";
import Navbar from "../../Components/Navbar";
import Config from "../../Config";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Campaigns/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import UpdateStatusModel from "../../Components/Applications/ConsentModel";
import UploadCertificateModel from "../../Components/Applications/UploadCertificateModel";
import CancellationNoticeModel from "../../Components/Applications/UploadNoticeModel";
import CancelModel from "../../Components/Applications/UploadCancelModel";
import AnnualFeesModal from "../../Components/Applications/AnnualFeeModal";
import AdminLCModal from "../../Components/Applications/AdminLCModal";
//import SingleEntry from "../../Components/Campaigns/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { toast } from "react-toastify";
import ViewModel from "../../Components/Applications/ViewModel";
import { useTranslation } from "react-i18next";

const RegisteredAssociation = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

  const [searchType, setSearchType] = useState("0");
  //const [searchValue, setSearchValue] = useState(email || "");
  const [adminLCModel, setAdminLCModel] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("all");

  const [adminLCApiData, setAdminLCApiData] = useState(false);
  const [openViewModel, setOpenViewModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateStatusModel, setOpenUpdateStatusModel] = useState(false);
  const [openUploadCertificateModel, setOpenUploadCertificateModel] =
    useState(false);
  const [openCancellationNoticeModel, setOpenCancellationNoticeModel] =
    useState(false);
  const [openCancelModel, setOpenCancelModel] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const [editDevice, setEditDevice] = useState(false);

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const navigate = useNavigate();

  const { id } = useParams();
  const { t, i18n } = useTranslation();

  // // ----- Getting Initial Data ------
  const fetchFunction = async (value) => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", 0);
    body.append("filter", filter);
    body.append("filterValue", filterValue);

    return await axios.post(`${Config.apiUrl}/registeredassociations`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  // const { isLoading, error, data, refetch, isRefetching } = useQuery(
  //   "getMyRequestsList",
  //   fetchFunction
  // );

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    getAppRegMutate(searchType);
  }, []);

  const initialValues = {
    filterVal: "",
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandlerTypeSearch = (values) => {
    {
      setFilterValue(values.filterVal);
    }
    getAppRegMutate(values);
    //refetch();
  };

  const TypeFilters = ({
    initialValues,
    submitHandlerTypeSearch,
    InitialLoading,
    user,
  }) => {
    return (
      <Formik initialValues={initialValues} onSubmit={submitHandlerTypeSearch}>
        <Form>
          <FilterContainer>
            <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">Search</Label>

              <Select
                autoComplete="off"
                className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  //searchHandler(e.target.value);
                }}
              >
                <MenuItem value="all">ALL</MenuItem>
                <MenuItem value="assocName">Assoc Name</MenuItem>
                <MenuItem value="assocNo">Assoc No.</MenuItem>
                <MenuItem value="region">Region</MenuItem>
                <MenuItem value="district">District</MenuItem>
              </Select>
            </InputGroup>
            <InputGroup className="max-w-xs">
              <Label htmlFor="filterVal">Value</Label>
              <FieldWrapper className="h-10">
                <Field
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  //value={filterValue}
                  onSubmit={(e) => {
                    setFilterValue(e.target.value);
                    //searchHandler(e.target.value);
                  }}
                  //  onSubmit={(e) => {
                  //   setFilterValue(e.target.value);
                  //   //searchHandler(e.target.value);
                  // }}
                />
              </FieldWrapper>
            </InputGroup>
            <ApplyBtn disabled={InitialLoading} type="submit">
              Search
            </ApplyBtn>
          </FilterContainer>
        </Form>
      </Formik>
    );
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilter("date");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getAppRegMutate(searchType);
    //getReportsMutate(newValues);
  };

  const searchHandler = (value) => {
    setSearchType(value);
    getAppRegMutate(value);
    //getReportsMutate(newValues);
  };

  /*********** Export Function *********** */

  const getPaymentsExportApi = async () => {
    const body = new FormData();
    // body.append("filter", filter);
    // body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", 0);
    return await axios.post(
      `${Config.apiUrl}/exportregisteredassociations`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  };

  const GetExportDataSuccess = (data) => {
    window.open(data.data.path, "_blank");
  };

  const GetExportDataError = (data) => console.log("error", data);

  const { isLoading: InitialLoadingForExport, mutate: getPaymentsExport } =
    useMutation(getPaymentsExportApi, {
      onSuccess: GetExportDataSuccess,
      onError: GetExportDataError,
    });

  /*********** End Export Function *********** */

  const submitHandlerForExport = (values) => {
    //console.log("submitHandlerForExport");
    // const formatDates = {
    //   startDate: prevDate,
    //   endDate: today,
    // };

    //getPaymentsExport(formatDates);
    getPaymentsExport();
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>Registered Associations Report</Title>
              <Underline />
            </div>
          </div>

          <div className="flex items-end justify-between">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
              submitHandlerForExport={submitHandlerForExport}
            />

            <TypeFilters
              submitHandlerTypeSearch={submitHandlerTypeSearch}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
            />

            {/* <InputGroup className="max-w-xs"  style={{flexBasis: 'content'}}>
            <Label htmlFor="startDate">Status</Label>
            <Select
                autoComplete="off"
                className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                value={searchType}
                onChange={(e) => searchHandler(e.target.value)}
              >
                  <MenuItem value="0">All</MenuItem>
                  <MenuItem value="1">Pending Docs</MenuItem>
                  <MenuItem value="2">Pending Payments</MenuItem>
                  <MenuItem value="3">InProgress</MenuItem>
                  <MenuItem value="4">Approved By Asst</MenuItem>
                  <MenuItem value="5">Completed</MenuItem>
                  <MenuItem value="6">Certificate Issued</MenuItem>
                  <MenuItem value="10">Rejected</MenuItem>
              </Select>
              </InputGroup> */}
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              gTypeOfGame={gTypeOfGame}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              <Table
                ApiData={
                  error || data?.data.data == false ? [] : data?.data.data
                }
                // setOpenDeleteModel={setOpenDeleteModel}
                setSelectedItem={setSelectedItem}
                setOpenViewModel={setOpenViewModel}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  submitHandlerForExport,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Filter
          </ApplyBtn>

          {/* <p
              className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm"
              type="submit"
              onClick={submitHandlerForImport}
            >
              Import
            </p> */}
          <p
            className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm cursor-pointer"
            disabled={InitialLoading}
            type="button"
            onClick={submitHandlerForExport}
          >
            Export
          </p>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

// const Uploader = ({ setOpenUploadModel }) => {
//   return (
//     <UploadWrapper>
//       <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
//       </Button>
//       {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
//       </Button> */}
//     </UploadWrapper>
//   );
// };

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default RegisteredAssociation;
